import React from "react";

import {
  ShieldCheck,
  TrendingUp,
  Users,
  ArrowRight,
} from "lucide-react";

import "../Styles/Home.css";

import logo from "../assets/logo.png";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div className="modern-home-wrapper">

      {/* HERO SECTION */}
      <section className="modern-hero-section">

        <div className="modern-hero-overlay" />

        <div className="modern-hero-content">

          {/* LEFT SIDE */}
          <div className="modern-hero-left">

            <div className="modern-logo-card">
              <img
                src={logo}
                alt="RCS Logo"
                className="modern-home-logo"
              />
            </div>

          </div>

          {/* RIGHT SIDE */}
          <div className="modern-hero-right">

            <div className="modern-badge">
              RCS TOPUP & BILLING ENTITY
            </div>

            <h1 className="modern-main-heading">
              RELIABLE.
              <br />
              EFFICIENT.
              <br />
              <span>BUILT FOR YOU.</span>
            </h1>

            <p className="modern-hero-text">
              Featuring a vast collection of financial services
              tailored for our customers, agents, partners and
              investors across Guyana.
            </p>

            <div className="modern-hero-actions">

<Link
  to="/services"
  className="modern-primary-btn"
>
  Explore Services
  <ArrowRight size={18} />
</Link>

            </div>

            <div className="modern-nav-note">
              Please use the navigation tabs above to
              access your destination.
            </div>

          </div>

        </div>

      </section>

      {/* FEATURES */}
      <section className="modern-features-section">

        <div className="modern-feature-card">

          <div className="modern-feature-icon">
            <ShieldCheck size={30} />
          </div>

          <div>
            <h3>Trusted & Secure</h3>

            <p>
              Your transactions are done in confidence
            </p>
          </div>

        </div>

        <div className="modern-feature-card">

          <div className="modern-feature-icon">
            <TrendingUp size={30} />
          </div>

          <div>
            <h3>Financial Growth</h3>

            <p>
              Services designed to help customers,
              agents and investors grow confidently.
            </p>
          </div>

        </div>

        <div className="modern-feature-card">

          <div className="modern-feature-icon">
            <Users size={30} />
          </div>

          <div>
            <h3>Customer Focused</h3>

            <p>
              Delivering reliable service and support
              across Guyana.
            </p>
          </div>

        </div>

      </section>

    </div>
  );
};

export default Home;